module.exports = __webpack_public_path__ + "img/build-a-bot-logo.bdca6725.png";